import React from "react";
import HeaderBar from "web/react/components/app-header/header-bar/header-bar";
import PreHeaderBar from "web/react/components/app-header/pre-header-bar/pre-header-bar";
import { SetPaidSessionIdOnLinks } from "web/react/components/set-paid-session-id-on-links/set-paid-session-id-on-links";
import { SkipNavigationButton } from "web/react/components/skip-navigation-button/skip-navigation-button";
import { AppHeaderBarSerializer, AppPreHeaderBarSerializer } from "web/types/serializers";
import "./app-header.module.css";

interface AppHeaderProps {
    headerBar: AppHeaderBarSerializer;
    preHeaderBar: AppPreHeaderBarSerializer;
}

function AppHeader({ headerBar, preHeaderBar }: AppHeaderProps): React.ReactElement {
    return (
        <>
            <SetPaidSessionIdOnLinks />
            <PreHeaderBar
                accountDropdown={preHeaderBar.account_dropdown}
                accountText={preHeaderBar.account_text}
                accountUrl={preHeaderBar.account_url}
                countryInfo={preHeaderBar.country_info}
                languageSelector={preHeaderBar.language_selector}
                registerUrl={preHeaderBar.register_url}
                showCountryPicker={preHeaderBar.show_country_picker}
            />
            <SkipNavigationButton />
            <HeaderBar
                genders={headerBar.genders}
                isHomePage={headerBar.is_homepage}
                homeUrl={headerBar.home_url}
                isAuthenticated={headerBar.is_authenticated}
                absoluteActionUrl={headerBar.absolute_action_url}
                absoluteHomeUrl={headerBar.absolute_home_url}
                mySearchesUrl={headerBar.my_searches_url}
                notificationsCount={headerBar.notifications_count}
                notificationsUrl={headerBar.notifications_url}
                hasItemsInWishlist={headerBar.has_items_in_whishlist}
                savedItemUrl={headerBar.saved_item_url}
                searchInput={headerBar.search_input}
                userDropdown={{
                    accountDropdown: preHeaderBar.account_dropdown,
                    accountText: preHeaderBar.account_text,
                    accountUrl: preHeaderBar.account_url,
                    registerUrl: preHeaderBar.register_url,
                }}
            />
            {/* empty div used for header-bar-search React portal */}
            <div id="app-header-search-bar-mobile" className="hidden-desktop" />
        </>
    );
}

export default AppHeader;
